<!--
TODO:
- i18n

-->
<template>
  <IconButton :label="copied ? 'Copiado!' : 'Copiar'" @click="copy()">
    <ClipboardCopyIcon v-if="!copied" />
    <ClipboardCheckIcon v-else class="text-success-30 rotate-6 transform" />
  </IconButton>
</template>

<script>
import IconButton from "@atoms/IconButton";
import { ClipboardCopyIcon, ClipboardCheckIcon } from "@heroicons/vue/outline";
import { useClipboard } from "@vueuse/core";

export default {
  name: "ClipboardButton",
  components: { IconButton, ClipboardCopyIcon, ClipboardCheckIcon },
  props: {
    text: { type: String, required: true },
  },
  setup(props) {
    const { copy, copied } = useClipboard({ source: props.text });

    return { copy, copied };
  },
};
</script>
